import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function Toast({
  glyph,
  tone,
  action,
  onAction,
  children,
}: {
  glyph?: ReactNode;
  tone?: 'ok' | 'acc';
  action?: string;
  onAction?: () => void;
  children: ReactNode;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-toast
      className={cn(
        'bg-muted animate-rise-fast rounded-ctl fixed inset-x-3 z-45 mx-auto flex max-w-[576px] items-center gap-2.5 border px-3.25 py-2.75 shadow-[0_10px_26px_rgba(0,0,0,0.3)]',
        'bottom-[calc(var(--dock-h,58px)/var(--zoom,1)+12px)]',
        tone === 'ok' ? 'border-ok' : 'border-border-strong',
      )}
    >
      {tone === 'ok' ? (
        <span
          aria-hidden
          className="bg-ok text-t12 rounded-2xs flex size-5.5 flex-none items-center justify-center font-extrabold text-[#0b2a17]"
        >
          ✓
        </span>
      ) : (
        glyph !== undefined && (
          <span aria-hidden className="text-t15 flex-none leading-none">
            {glyph}
          </span>
        )
      )}
      <span className="text-t12h min-w-0 flex-1 leading-[1.35] font-bold">{children}</span>
      {action && (
        <button
          type="button"
          onClick={onAction}
          className="border-border-strong text-foreground text-t12 min-h-11 flex-none rounded-xs border px-3 font-extrabold"
        >
          {action}
        </button>
      )}
    </div>
  );
}

export function TipPill({ glyph, children }: { glyph: ReactNode; children: ReactNode }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-muted border-border-strong animate-rise-fast fixed bottom-[calc(var(--dock-h,58px)/var(--zoom,1)+12px)] left-1/2 z-45 flex w-max max-w-[calc(100%-32px)] -translate-x-1/2 items-center gap-2.25 rounded-full border px-4 py-2.5 shadow-[0_10px_26px_rgba(0,0,0,0.3)]"
    >
      <span aria-hidden className="text-accent-ink text-t14 flex-none font-extrabold">
        {glyph}
      </span>
      <span className="text-t12h font-bold">{children}</span>
    </div>
  );
}
